/**
 * Converts a Base64 string to a Blob URL.
 * Assumes the Base64 string is the raw data part (no 'data:mime/type;base64,' prefix).
 */
export const base64ToBlobUrl = (base64, mimeType) => {
  if (!base64 || !mimeType) {
    console.error('Missing base64 data or mimeType.');
    return '';
  }
  let rawBase64Data = base64;

  if (base64.includes(',')) {
    [, rawBase64Data] = base64.split(',');
  }

  let cleanedBase64 = rawBase64Data.replace(/\s/g, '');
  cleanedBase64 = cleanedBase64.replace(/-/g, '+').replace(/_/g, '/');
  try {
    const byteCharacters = atob(cleanedBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: mimeType });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Base64 Decoding Failed. Is the string valid?', error);
    return '';
  }
};

export const getMimeTypeFromDataURI = (dataURI) => {
  if (!dataURI.startsWith('data:')) {
    return null;
  }

  const semiColonIndex = dataURI.indexOf(';');
  const mimeType = dataURI.substring(5, semiColonIndex);

  return mimeType;
};
